import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransfersPage, { getDefaultPageUI } from "components/pages/TransfersPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureLoanTransferFromDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(undefined, context))
    .update([ "from", "isActive" ], true)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <TransfersPage ui={ ui } />
}